import type { CaseDocument, VehicleCategory } from '../types/case';
import type { DocRule } from '../types/config';

export function buildDocuments(
  category: VehicleCategory,
  rules: DocRule[],
  fill: Record<string, Partial<CaseDocument>> = {},
): CaseDocument[] {
  return rules
    .filter((r) => r.active && !r.excludeCategories.includes(category))
    .map((r) => ({ key: r.key, name: r.name, required: true, status: 'none' as const, ...fill[r.key] }));
}

export function fillAll(category: VehicleCategory, rules: DocRule[], patch: Partial<CaseDocument>): CaseDocument[] {
  const fill: Record<string, Partial<CaseDocument>> = {};
  rules.forEach((r) => {
    fill[r.key] = { ...patch, fileName: `${r.key}_scan.${patch.fileType === 'pdf' ? 'pdf' : 'jpg'}` };
  });
  return buildDocuments(category, rules, fill);
}
